import { render } from "./DeleteContactModal.vue?vue&type=template&id=9ad90d3c&scoped=true"
import script from "./DeleteContactModal.vue?vue&type=script&lang=js"
export * from "./DeleteContactModal.vue?vue&type=script&lang=js"

import "./DeleteContactModal.vue?vue&type=style&index=0&id=9ad90d3c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ad90d3c"]])

export default __exports__